import React from 'react'
import Component from './component'

const Container = (props) => {
  const { parentModelName, row, disableTarget } = props || {}

  const currentTarget = row?.target

  const targetHierarchy = ['company', 'companycontract', 'companyservice', 'companyuser']
  const parentIndex = _.indexOf(targetHierarchy, parentModelName)
  const targetIndex = _.indexOf(targetHierarchy, currentTarget)
  const disabledTargets = _.slice(targetHierarchy, 0, parentIndex !== -1 ? parentIndex : 0)
  const isDisabled = targetIndex !== -1 && targetIndex < parentIndex

  const mergedProps = {
    isDisabled,
    currentTarget,
    disabledTargets,
    disableTarget,
  }

  return (
    <Component {...mergedProps} {...props} />
  )
}
export default Container
